<template>
  <span>
    <span class="ft-12"
      >商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link></span
    >
    <GroupImagesList :baseItemId="alibabaFormVm.form.baseItemId" :hideImgs="['detailImages', 'mainImages34']" :specifications="alibabaSpecifications" @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
  </span>
</template>

<script>
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue';
import storeMixins from '../store-mixins';

export default {
  components: {
    GroupImagesList,
  },
  inject: ['alibabaFormVm'],
  mixins: [storeMixins],
  props: ['props'],
  computed: {
    key() {
      return this.props.name;
    },
  },
  methods: {
    useGroupImages(data, type) {
      const { mainImages = [], speImages = [] } = data;
      let pic = [];
      if (type === 'add') {
        pic = [...this.alibabaForm.primaryPicture].filter(Boolean);
      }
      if(mainImages.length) {
        pic = [...pic, ...mainImages].filter(Boolean).slice(0, 5)
        this.updateAlibabaForm({primaryPicture: pic})
      }
      const specifications = this.alibabaSpecifications;
      const firstSpec = specifications[0];
      if (firstSpec && firstSpec.values && speImages.length) {
          firstSpec.values.forEach(specValue => {
              // 如果是新增模式且已有图片，则跳过
              if (type === 'add' && specValue.imageUrl) {
                  return;
              }
              
              // 查找匹配的图片
              const matchedImage = speImages.find(img => img.name === specValue.value);
              if (matchedImage) {
                  specValue.imageUrl = matchedImage.imgUrl;
              }
          });
      }
      this.updateAlibabaSpecifications(specifications)
    },
    getGroupImagesList(list) {
      this.updateAlibabaForm({showGroupImages: !!list?.length})
    },
    editGroupImages() {
      this.alibabaFormVm.changeToBase('openGroupImgs');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>